'use strict';

module.exports = {
    SIGN: 'Accedi',
    SIGN_JOIN: 'Registrati o diventa membro gratis!',
    EMAIL_EXISTS: 'Questo account esiste già.',
    INVALID_EMAIL: 'Inserisci un indirizzo e-mail valido',
    INVALID_FIRST_NAME: 'Inserisci un nome valido',
    INVALID_LAST_NAME: 'Inserisci un cognome valido',
    INVALID_PASSWORD: 'Inserisci da 6 a 20 caratteri (solo A-Z, a-z, 0-9)',
    INVALID_REPASSWORD: 'Le password non corrispondono',
    INVALID_VALID_CODE: 'Inserisci un codice valido',
    UNAVIALABLE_SERVICE: 'Il servizio non è disponibile, si prega di riprovare più tardi.',
    EMPTY_VALID_CODE: 'Digita solo i caratteri che vedi nell\'immagine',
    NOT_MEMBER: 'Non sei un membro?',
    ALREADY_MEMBER: 'Sei già membro di AliExpress/Alibaba?',
    EMAIL: 'Indirizzo email',
    CONTACT_NAME: 'Nome di contatto:',
    FIRST_NAME: 'Nome',
    LAST_NAME: 'Cognome',
    PASSWORD: 'Parola d\'ordine',
    REPASSWORD: 'Reinserisci la password:',
    EMPTY_CODE: 'Inserisci il codice visualizzato:',
    REFRESH: 'Aggiorna',
    CREATE_MY_ACCOUNT: 'Crea il mio account',
    NAME: 'Nome',
    VERIFICATION: 'Codice di Verifica',
    AGREE_MENT: 'Creando un account, accetti il',
    AE_MEMBER_SHIP: 'Accordo di membership gratuita di AliExpress.com',
    AND: 'e',
    PRIVACY_POLICY: "l'Informativa sulla privacy",
    SLIDE_SUBMIT: 'Scorrere a destra per verificare',
    SLIDE_SUBMIT_TIPS: 'Successo',
    LOADING: 'Caricamento in corso…',
    SLIDE_SUBMIT_ERROR_TIPS: 'Scorrere a destra per verificare',
    SHOP_NOW: 'COMPRA ORA',
    SIGN_IN: 'Registrati',
    REGISTER_SMS: 'Registrati con SMS',
    REGISTER_EMAIL: 'Registrati con email',
    PHONE_NUMBER: 'Numero di telefono',
    VALID_NUMBER: 'Inserisci un numero di telefono valido.',
    SEND_SMS_CODE: 'Invia codice SMS',
    SMS_POLICY: 'Ti invieremo un codice di verifica via SMS al numero di telefono che hai inserito. Assicurati che sia il codice del paese che il numero di telefono siano corretti.',
    SEND_TO: 'Abbiamo inviato il codice a',
    VERIFICATION_RECEIVED: 'Inserisci il codice di verifica che hai ricevuto oppure',
    EDIT_NUMBER: 'modifica il numero.',
    RESEND_CODE: 'Reinvia codice',
    LAST_STEP: 'Ultimo passaggio',
    SET_SIGN_IN_PASSWORD: 'Imposta una password di accesso per rendere più sicuro il tuo account.',
    INVALID_PHONE_PASSWORD: '6-20 caratteri (solo lettere e numeri)',
    NOT_CORRECT_CODE: 'Il codice non è corretto, riprova.',
    SAVE_PASSWORD: 'Salva password',
    NO_RECEIVED_CODE: 'Se non hai ancora ricevuto il codice, prova a',
    VIA_EMAIL: 'Registrati via email',
    GUID: 'Vuoi vendere su AliExpress?',
    GUID_HREF: 'Clicca qui'
};